import React from 'react'
import styled from 'styled-components'
import {_L, useLocaleState} from '../../context/LocaleContext'

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 40px;
  grid-column-gap: 8px;
  justify-items: start;
  align-items: center;
  box-sizing: border-box;
  padding: 8px;
  font-weight: 700;

  @media (max-width: 520px) {
    display: none;
  }
`

const KioskEquipmentHeader = () => {
  const localeState = useLocaleState()

  return (
    <Container>
      <div>{_L({key: 'Equipment Standard', localeState})}</div>
      <div>{_L({key: 'Equipment Code', localeState})}</div>
      <div>{_L({key: 'Building Code', localeState})}</div>
      <div>{_L({key: 'Floor Code', localeState})}</div>
      <div>{_L({key: 'Room Code', localeState})}</div>
    </Container>
  )
}

export default KioskEquipmentHeader
